import { defineMessages } from 'react-intl'

export default defineMessages({
  selected: {
    id: "containers.CustomerOrderUpsertPage.components.Draft.selected",
    defaultMessage: "Your order won't be submitted automatically.\nA project manager at VoiceArchive will review the order before proceeding.",
  },
})